import { createSlice } from "@reduxjs/toolkit";

import { SiteLogoThunk } from "../Thunk/SiteLogoThunk";

let initState = {
	reload: false,
	siteLogoData: {},
};

const SiteLogoReducer = createSlice({
	name: "SiteLogo",

	initialState: initState,
	reducers: {},
	extraReducers: (builder) => {
		builder

			.addCase(SiteLogoThunk.pending, (state) => {
				state.reload = true;
			})
			.addCase(SiteLogoThunk.fulfilled, (state, action) => {
				state.reload = false;
				state.siteLogoData = action.payload.data;
			})
			.addCase(SiteLogoThunk.rejected, (state, action) => {
				state.reload = false;
				state.error = action.error.message;
			});
	},
});
export default SiteLogoReducer.reducer;
